// Any config specific to KSA?

export default {
  code: 'SA',
  countryName: 'KSA',
  googleSiteVerificationCode: [
    'LVneaZHf1h8BShbZXOIQGmQ_xcinQsOPltci6L3HJHc',
    'JJMurY1JmL5Ch9O60RFyH0e36MqA89e_QKFqkcNBVXk',
    '4ardQ0UCe5r-8OGjhQ1-rl_-Z3-XPg7tlmEJ-QHbG0s'
  ],
  helplineNumber: '920000282',
  countryDomain: 'https://www.carrefourksa.com',
  latitude: 24.7136,
  longitude: 46.6753,
  countryFlagIcon: 'SA_090b37bfc2.png',
  defaultAreaCode: 'Granada - Riyadh',
  features: {
    languageChange: true,
    now: false,
    share: false,
    isLocationCXEnable: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '75195de9-335a-47f1-bca6-43714dbbb529'
  },
  metaVerificationTag: 'ab0808e4ad'
}
